// extracted by mini-css-extract-plugin
export var $animation_name = "CompetitionHeader-module--$animation_name--5547b";
export var CtaButtons = "CompetitionHeader-module--CtaButtons--4652e";
export var bannerImage = "CompetitionHeader-module--bannerImage--27ae5";
export var copy = "CompetitionHeader-module--copy--3449f";
export var lockupImage = "CompetitionHeader-module--lockupImage--24515";
export var partnerLogo = "CompetitionHeader-module--partnerLogo--8bea8";
export var theme_black = "CompetitionHeader-module--theme_black--c3541";
export var theme_white = "CompetitionHeader-module--theme_white--e53ca";
export var title = "CompetitionHeader-module--title--83261";
export var wrapper = "CompetitionHeader-module--wrapper--ec355";
export var wrapper__withLinks = "CompetitionHeader-module--wrapper__withLinks--ba62f";